<template>
  <div
      class="fixed w-[459px] max-w-full sm:max-w-none !z-20 duration-500 xl:start-0 xl:relative before:absolute before:content-[''] before:top-[45px] before:start-[-15px] before:bg-[#5F6F7B] before:w-full before:sm:w-[459px] xl:before:w-full before:h-[calc(100vh-95px)] before:rounded-[30px]"
      :class="{'start-[0] xl:!start-[-50px] xl:-ms-[459px]': isActiveSidebar, '-start-[125%]': !isActiveSidebar }"
      id="sidebar">

    <div
        class="w-full rounded-[10px] sm:rounded-[30px] p-[11px] bg-[#E0E9F0] relative z-2 mt-[22px] z-[999] overflow-y-scroll scrollbar">

      <!--    map-->
      <div class="w-full h-[calc(100vh-105px)] rounded-[30px] bg-no-repeat bg-cover object-cover"
           :style="{backgroundImage: 'url(/assets/images/map.png)'}">
        <div class="w-full h-full flex justify-between items-center flex-col">

          <!--      header-->
          <div class="w-full bg-gradient-to-b from-[#E0E9F0] to-[#eef4f9] py-[7px] px-[8px]">

            <!--        toggle button and select language-->
            <div class="flex justify-between items-center flex-col sm:flex-row">

              <!--          toggle button-->
              <button type="button"
                      class="z-50 border-0 bg-transparent outline-0 p-0 m-0  flex-col bg-[#798B97] w-[72px] h-[64px] flex justify-center items-center rounded-[20px]"
                      id="hamburger" @click="handleSidebar">
                <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black mb-[3px]"></span>
                <span class="w-[30px] rounded-[5px] h-[3.5px] inline-block bg-black mb-[3px]"></span>
                <span class="w-[30px] rounded-[5px] h-[4px] inline-block bg-black"></span>
              </button>

              <!--          select language-->
              <div class="flex justify-end items-center gap-x-[5px]">
                <button type="button"
                        class="outline-0 border-0 bg-[#8495A1]  text-[#C6A798] w-[95px] h-[50px] flex justify-center items-center text-[19px] font-medium p-0 rounded-[10px] duration-500 hover:bg-[#33464A] hover:text-[#C6A798]"
                        :class="{'!bg-[#33464A]': lang == 'en'}"
                        @click="changeLang('en')">
                  English
                </button>
                <button type="button"
                        class="outline-0 border-0 bg-[#8495A1]  text-[#C6A798] w-[95px] h-[50px] flex justify-center items-center text-[19px] font-medium p-0 rounded-[10px] duration-500 hover:bg-[#33464A] hover:text-[#C6A798]"
                        :class="{'!bg-[#33464A]': lang == 'ar'}"
                        @click="changeLang('ar')">
                  العربية
                </button>
              </div>
            </div>

            <!--        logo-->
            <a href="">
              <img :src="'/assets/images/logo.png'"
                   class="w-[198.36px] mx-auto mt-[21.7px] mb-[23.8px]"
                   width="198.36"
                   height="53"
                   alt="logo">
            </a>

            <!--        delivery and pickup button-->
            <div class="flex justify-center items-center gap-x-[6px]">

              <!--          delivery button-->
              <div>
                <button type="button"
                        class="bg-[#798B97] duration-500 hover:bg-[#3E5463] border-0 outline-0 text-[#FFFFFF] font-medium w-[140px] sm:w-[161.02px] px-[15.5px] py-[11px] rounded-[10px] flex justify-start items-center"
                        :class="{'!bg-[#3E5463]': deliveryStatus === 1}"
                        @click="setDeliveryStatus(1)">
                  <img :src="'/assets/svg/delivery.svg'"
                       width="35.269"
                       height="33.34"
                       alt="delivery">
                  <span class="ms-[14.7px] mb-[-5px]"> {{ lang === 'en' ? 'Delivery' : 'توصيل' }} </span>
                </button>
              </div>

              <div>
                <button type="button"
                        class="bg-[#798B97] duration-500 hover:bg-[#3E5463] border-0 outline-0 text-[#FFFFFF] font-medium w-[140px] sm:w-[161.02px] px-[15.5px] py-[11px] rounded-[10px] flex justify-start items-center"
                        :class="{'!bg-[#3E5463]': deliveryStatus === 2}"
                        @click="setDeliveryStatus(2)">
                  <img :src="'/assets/svg/pickup.svg'"
                       width="35.596"
                       height="35.547"
                       alt="pickup">

                  <span class="ms-[14.7px] mb-[-5px]"> {{ lang === 'en' ? 'Pickup' : 'يلتقط' }} </span>
                </button>
              </div>
            </div>


            <!--        Office address-->
            <div class="w-full flex justify-center mt-[6.4px]" v-if="deliveryStatus == 1 && userInfo">
              <div class="w-[287px] sm:w-[328px] mx-auto relative" v-if="addresses.length > 0">
                <button type="button"
                        class="border-0 outline-0 bg-[#C6A798] pl-[8.1px] pr-[12.9px] py-[6.1px] flex justify-between items-center rounded-[10px] h-[55.25px] w-full"
                        id="locationBtn" @click="openAddress">
                      <span class="flex justify-start items-center">
                        <span
                            class="flex justify-center items-center w-[41.99px] h-[43.09px] bg-white rounded-full">
                            <svg id="Pin" xmlns="http://www.w3.org/2000/svg" width="21.222" height="28.296"
                                 viewBox="0 0 21.222 28.296">
                                <path id="Path_2043" data-name="Path 2043"
                                      d="M18.611,0A10.625,10.625,0,0,0,8,10.611c0,7.618,9.886,17.159,10.306,17.561a.438.438,0,0,0,.61,0c.42-.4,10.306-9.943,10.306-17.561A10.625,10.625,0,0,0,18.611,0Zm0,15.474a4.863,4.863,0,1,1,4.863-4.863A4.863,4.863,0,0,1,18.611,15.474Z"
                                      transform="translate(-8)" fill="#798b97"/>
                            </svg>
                        </span>
                        <span class="ms-2 inline-block text-start text-white">
                            <span class="block text-[18px]"> {{ selectedLocation.name }} </span>
                            <span class="block text-[9px]">
                              {{ selectedLocation.building_details }}
                            </span>
                        </span>
                    </span>
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="17.346" height="10.191"
                         viewBox="0 0 17.346 10.191">
                      <g id="Group_462" data-name="Group 462" transform="translate(17.346) rotate(90)">
                        <g id="Group_374" data-name="Group 374" transform="translate(0 0)">
                          <path id="Path_2021" data-name="Path 2021"
                                d="M9.914,8,2.195.277a.951.951,0,0,0-1.342,0L.284.845a.95.95,0,0,0,0,1.342L6.766,8.669.277,15.158a.951.951,0,0,0,0,1.342l.568.568a.951.951,0,0,0,1.342,0L9.914,9.343A.958.958,0,0,0,9.914,8Z"
                                fill="#798b97"/>
                        </g>
                      </g>
                    </svg>
                </span>
                </button>
                <div
                    class="bg-[#C6A798] px-[8.1px] py-[6.1px] overflow-auto block absolute left-0 top-[60px] rounded-[10px] w-[287px] sm:w-full h-[250px] z-20 scrollbar"
                    id="officeAddress" v-if="showAddress">
                  <button type="button"
                          class="h-[59px] mx-auto overflow-hidden py-[12.8px] px-[19.8px] bg-white rounded-[10px] flex justify-start items-center w-full mb-2"
                          v-for="(each) in addresses" :key="each.id" @click="setAddress(each)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24.935" height="33.246"
                         viewBox="0 0 24.935 33.246">
                      <g id="Pin" transform="translate(-8)">
                        <path id="Path_2043" data-name="Path 2043"
                              d="M20.467,0A12.484,12.484,0,0,0,8,12.467C8,21.418,19.615,32.628,20.109,33.1a.514.514,0,0,0,.717,0c.493-.473,12.109-11.683,12.109-20.633A12.484,12.484,0,0,0,20.467,0Zm0,18.181a5.714,5.714,0,1,1,5.714-5.714A5.714,5.714,0,0,1,20.467,18.181Z"
                              fill="#8cc63f"/>
                      </g>
                    </svg>
                    <span class="text-start inline-block"
                          :class="{'ml-[17.8px]': lang == 'en', 'mr-[17.8px]': lang == 'ar'}">
                          <span class="block text-[#3E5463] font-medium"> {{ each.name }} </span>
                          <span class="block text-[#3E5463]"> <div
                              class="truncate-to-1-line"> {{ each.building_details }}</div> </span>
                      </span>
                  </button>
                  <div v-if="getAddressLoading" class="h-full w-full flex items-center">
                    <LoaderVue/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--      map location-->
          <a href="javascript:void(0)" v-if="false">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-[27.73px] h-[63.266px]"
                 viewBox="0 0 27.73 63.266">
              <path id="Path_2189" data-name="Path 2189"
                    d="M33.595,67.277a1.13,1.13,0,0,0,1.13-1.13V31.694a13.865,13.865,0,1,0-2.26,0V66.147A1.13,1.13,0,0,0,33.595,67.277ZM25.4,16.089a8.41,8.41,0,0,1,5.537-6.17,1.126,1.126,0,1,1,.712,2.136,6.165,6.165,0,0,0-4.045,4.509,1.121,1.121,0,0,1-1.1.893,1.857,1.857,0,0,1-.249-.023,1.126,1.126,0,0,1-.859-1.345Z"
                    transform="translate(-19.73 -4.011)" fill="#3e5463"/>
            </svg>
          </a>
          <div v-if="false">
            <svg xmlns="http://www.w3.org/2000/svg"
                 class="w-[27.422px] h-[39px] relative left-[90px] top-[-35px]"
                 viewBox="0 0 27.422 39">
              <g id="Group_488" data-name="Group 488" transform="translate(-76)">
                <path id="Path_2190" data-name="Path 2190"
                      d="M89.711,0A13.722,13.722,0,0,0,76,13.711a13.52,13.52,0,0,0,2.057,7.2L88.781,38.46a1.083,1.083,0,0,0,.777.526,1.137,1.137,0,0,0,1.165-.548L101.48,20.726a13.522,13.522,0,0,0,1.942-7.015A13.722,13.722,0,0,0,89.711,0Zm0,20.566a6.855,6.855,0,1,1,6.855-6.855A6.846,6.846,0,0,1,89.711,20.566Z"
                      fill="#fd003a"/>
                <path id="Path_2191" data-name="Path 2191"
                      d="M256,0V6.855a6.855,6.855,0,0,1,0,13.711V39a1.131,1.131,0,0,0,1.013-.562l10.755-17.711a13.522,13.522,0,0,0,1.942-7.015A13.722,13.722,0,0,0,256,0Z"
                      transform="translate(-166.289)" fill="#e50027"/>
              </g>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg"
                 class="w-[27.422px] h-[39px] relative left-[-90px] top-[35px]"
                 viewBox="0 0 27.422 39">
              <g id="Group_488" data-name="Group 488" transform="translate(-76)">
                <path id="Path_2190" data-name="Path 2190"
                      d="M89.711,0A13.722,13.722,0,0,0,76,13.711a13.52,13.52,0,0,0,2.057,7.2L88.781,38.46a1.083,1.083,0,0,0,.777.526,1.137,1.137,0,0,0,1.165-.548L101.48,20.726a13.522,13.522,0,0,0,1.942-7.015A13.722,13.722,0,0,0,89.711,0Zm0,20.566a6.855,6.855,0,1,1,6.855-6.855A6.846,6.846,0,0,1,89.711,20.566Z"
                      fill="#fd003a"/>
                <path id="Path_2191" data-name="Path 2191"
                      d="M256,0V6.855a6.855,6.855,0,0,1,0,13.711V39a1.131,1.131,0,0,0,1.013-.562l10.755-17.711a13.522,13.522,0,0,0,1.942-7.015A13.722,13.722,0,0,0,256,0Z"
                      transform="translate(-166.289)" fill="#e50027"/>
              </g>
            </svg>

          </div>
          <!--      google map-->
          <GoogleMapComponent :activeBranch="activeBranch" @handleAddress="handleAddress"/>

          <!--      footer-->
          <div class="w-full py-[7px] px-[8px]">

            <!--        information-->
            <div class="w-full bg-[#C1D5E5] rounded-[25px] py-[21px] px-[10px] sm:ps-[31px] sm:pe-[28px]"
                 v-if="deliveryStatus === 1 && location">
              <button type="button"
                      class="w-full h-[59px] py-[12.8px] px-[19.8px] shadow-[0_6px_6px_0_#ADC2D2] bg-white rounded-[10px] flex justify-start items-center"
                      v-if="userInfo">
                <svg xmlns="http://www.w3.org/2000/svg" width="24.935" height="33.246"
                     viewBox="0 0 24.935 33.246">
                  <g id="Pin" transform="translate(-8)">
                    <path id="Path_2043" data-name="Path 2043"
                          d="M20.467,0A12.484,12.484,0,0,0,8,12.467C8,21.418,19.615,32.628,20.109,33.1a.514.514,0,0,0,.717,0c.493-.473,12.109-11.683,12.109-20.633A12.484,12.484,0,0,0,20.467,0Zm0,18.181a5.714,5.714,0,1,1,5.714-5.714A5.714,5.714,0,0,1,20.467,18.181Z"
                          fill="#8cc63f"/>
                  </g>
                </svg>
                <span class="text-start inline-block"
                      :class="{'ml-[17.8px]': lang == 'en', 'mr-[17.8px]': lang == 'ar'}">
                          <span class="block text-[#3E5463] font-medium"> {{ location.address }} </span>
                          <span class="block text-[#3E5463]"> <div class="truncate-to-1-line"> {{ location.city }}</div> </span>
                      </span>
              </button>

              <form @submit.prevent="manageAddress">
                <div
                    class="w-full rounded-[10px] bg-white shadow-[0_6px_6px_0_#ADC2D2] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
                  <label for="address-name" class="text-[15px] text-[#3E5463]">
                    {{ lang === 'en' ? 'Address Name' : 'اسم العنوان' }} </label>
                  <input id="address-name" type="text" name="name" v-model="address.name"
                         class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]"
                         autoComplete="off"/>
                </div>
                <div class="text-red-700" v-if="addressError && addressError?.name">
                  {{ lang == 'en' ? 'Name is required.' : 'الاسم مطلوب.' }}.
                </div>

                <div
                    class="w-full rounded-[10px] bg-white shadow-[0_6px_6px_0_#ADC2D2] mt-[8px] h-[64px] mb-[6px] px-[19.8px] py-[9px]">
                  <label for="building-number" class="text-[15px] text-[#3E5463]">
                    {{ lang === 'en' ? 'Building Number' : 'رقم المبنى' }} </label>
                  <input id="building-number" type="text" name="building_details" v-model="address.building_details"
                         class="w-full border-0 outline-0 block text-[18px] font-medium text-[#3E5463]"
                         autoComplete="off"/>
                </div>
                <div class="text-red-700" v-if="addressError && addressError?.building_details">
                  {{ lang == 'en' ? 'Building number is required.' : 'رقم المبنى مطلوب.' }}
                </div>

                <!--          submit button of save address and delete-->
                <div class="w-full flex justify-center items-center mt-[9px] gap-x-[8px]">
                  <div class="w-2/3">
                    <button type="submit"
                            class="w-full h-[45px] bg-[#3E5463] hover:bg-[#33464A] duration-500 text-white rounded-[10px] flex justify-center items-center"
                            v-if="!addressLoading">
                      {{ lang === 'en' ? 'Save Address' : 'حفظ العنوان' }}
                    </button>
                    <button type="button"
                            class="w-full h-[45px] bg-[#3E5463] hover:bg-[#33464A] duration-500 text-white rounded-[10px] flex justify-center items-center"
                            :disabled="true"
                            v-if="addressLoading">
                      <span
                          class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                    </button>
                  </div>
                  <div class="w-1/3" v-if="address.id">
                    <button type="button"
                            class="w-full h-[45px] bg-[#B21221] hover:bg-[#9B101E] duration-500 text-white rounded-[10px] flex justify-center items-center"
                            @click="deleteAddress" v-if="!deleteAddressLoading">
                      {{ lang === 'en' ? 'Delete' : 'يمسح' }}
                    </button>
                    <button type="button"
                            class="w-full h-[45px] bg-[#B21221] hover:bg-[#9B101E] duration-500 text-white rounded-[10px] flex justify-center items-center"
                            :disabled="true" v-if="deleteAddressLoading">
                      <span
                          class="w-6 h-6 border-4 border-white border-t-gray-300 rounded-full animate-spin mx-auto block"></span>
                    </button>
                  </div>
                </div>
              </form>

            </div>
            <div class="w-full py-[7px] px-[8px] overflow-y-auto scrollbar h-[318.6px]" v-if="deliveryStatus === 2">
              <template v-if="!loading && branches.length > 0">
                <div
                    class="flex justify-start items-center w-full rounded-[10px] shadow-[0_3px_6px_0_#9BB9D1] mb-[7px] cursor-pointer"
                    :class="{'bg-gray-300': each.active, 'bg-[#F1F1F1]': !each.active}"
                    v-for="(each) in branches" :key="each.id" @click="sentBranchId(each)">
                  <img :src="each.imageUrl" height="134" width="134"
                       class="h-[134px] w-[134px] rounded-t-[10px] rounded-b-[10px]" alt="picture"/>
                  <div class="ms-[10.7px]">
                    <div class="text-[17px] sm:text-[19px] font-medium text-[#35474B]">
                      {{ each.name }}
                    </div>
                    <div class="text-[16px] text-[#35474B] font-light mb-[6.1px]">
                      {{ lang === 'en' ? 'Open until' : 'مفتوح حتى' }} 11:30 PM
                    </div>
                    <div class="text-[13px] font-light">
                      {{ each.address }}
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="!loading && branches.length === 0">
                <div class="h-full flex items-center justify-center">No branches found.</div>
              </template>
              <template v-if="loading">
                <LoaderVue/>
              </template>
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>

  <AuthModal :authModal="authModal" @handleCloseModal="handleCloseModal" />
</template>

<script>

import getLang from "@/utils/getLang";
import setLang from "@/utils/setLang";
import ApiService from "@/service/apiService";
import LoaderVue from "@/components/Loader.vue";
import GoogleMapComponent from "@/components/GoogleMapComponent.vue";
import getUserInfo from "@/utils/getUserInfo";
import Cookies from "js-cookie";
import {createToaster} from "@meforma/vue-toaster";
import AuthModal from "@/components/AuthModal.vue";

const toaster = createToaster({
  position: 'top-right'
});

/* global google */
export default {
  name: 'SidebarVue',
  components: {
    AuthModal,
    GoogleMapComponent,
    LoaderVue
  },
  data() {
    return {
      authModal: false,
      deliveryStatus: 1,
      branches: [],
      lang: window?.core?.lang,
      loading: false,
      settings: null,
      activeBranch: null,
      address: {
        id: '',
        user_id: '',
        name: '',
        lat: '',
        long: '',
        alt: '',
        building_details: '',
        type: '',
      },
      userInfo: null,
      addressError: null,
      addressLoading: false,
      deleteAddressLoading: false,
      showAddress: false,
      getAddressLoading: false,
      addresses: [],
      location: {
        city: '',
        address: ''
      },
      selectedLocation: {
        name: '',
        building_details: ''
      }
    }
  },
  props: {
    isActiveSidebar: {
      required: true
    }
  },
  computed: {},
  methods: {

    async getBranches(userInfo = null) {
      console.log(userInfo);
      try {
        this.loading = true;
        let origin = '21.549955,39.168488'; // Default origin

        console.log('[getBranches] Fetching branches with origin:', origin);
        const url = `/store/getBranches`;
        const response = await ApiService.post(url, { origin });

        if (!response.data?.data?.length) {
          console.error('[getBranches] No branches received from API');
          toaster.error(this.lang === 'en' ? 'No branches found' : 'لم يتم العثور على فروع');
          return;
        }

        toaster.info('Calculating distances. Please wait ... ')
        const branchesWithDistance = await Promise.all(
            response.data.data.map(async (branch) => {
              try {
                console.log('[getBranches] Processing branch:', branch.id, branch.name);
                const result = await this.calculateDistance(
                    origin,
                    `${branch?.lat || 0},${branch?.long || 0}`,
                    branch
                );
                return result;
              } catch (error) {
                console.error('[getBranches] Error processing branch', branch.id, error);
                return { ...branch, distance: null, error: error.message };
              }
            })
        );
        console.log(branchesWithDistance, 'branchesWithDistance');

        const distanceThreshold = this.settings?.[0]?.value ?? 50000;
        console.log('[getBranches] Using distance threshold:', distanceThreshold, 'meters');

        let validBranches = branchesWithDistance
            .filter(branch => branch.distance !== null && branch.distance <= distanceThreshold)
            .sort((a, b) => a.distance - b.distance);

        console.log('[getBranches] Found', validBranches.length, 'branches within threshold');

        if (validBranches.length === 0) {
          console.warn('[getBranches] No branches within threshold, falling back to all branches');
          toaster.warning(this.lang === 'en'
              ? 'No nearby branches found, showing all available branches'
              : 'لم يتم العثور على فروع قريبة، يتم عرض جميع الفروع المتاحة');

          validBranches = branchesWithDistance
              .filter(branch => branch.distance !== null)
              .sort((a, b) => a.distance - b.distance);
        }

        if (validBranches.length === 0) {
          console.warn('[getBranches] No valid distances, using original branch list');
          toaster.warning(this.lang === 'en'
              ? 'Could not calculate distances, showing all branches'
              : 'تعذر حساب المسافات، يتم عرض جميع الفروع');

          validBranches = response.data.data.map(branch => ({
            ...branch,
            distance: null,
            imageUrl: `${process.env.VUE_APP_IMAGE_URL}/${branch.image}`
          }));
        }

        this.branches = validBranches;
        console.log('[getBranches] Final branch list:', this.branches);

        if (this.branches.length > 0) {
          console.log('[getBranches] Activating first branch:', this.branches[0].id);
          await this.setActiveBranch(this.branches[0]);
        }

      } catch (error) {
        console.error('[getBranches] Critical error:', error);
        toaster.error(this.lang === 'en'
            ? 'Failed to load branches'
            : 'فشل تحميل الفروع');
      } finally {
        this.loading = false;
        console.log('[getBranches] Finished loading branches');
      }
    },

    async setActiveBranch(branch) {
      if (!branch) return;

      // Update all branches' active status
      this.branches = this.branches.map(b => ({
        ...b,
        active: b.id === branch.id,
        imageUrl: b.imageUrl || `${process.env.VUE_APP_IMAGE_URL}/${b.image}`
      }));

      this.activeBranch = branch;
      this.address = {
        ...this.address,
        lat: branch.lat,
        long: branch.long
      };

      // Update location information
      await this.getLocation(branch);

      // Emit event with branch ID
      this.$emit('setBranchId', branch.id);
    },

    async getLocation(data) {
      return new Promise((resolve, reject) => {
        if (!window.google || !window.google.maps) {
          console.error("Google Maps API not loaded yet.");
          reject("Google Maps API not loaded");
          return;
        }

        const geocoder = new google.maps.Geocoder();
        const latlng = {lat: Number(data.lat), lng: Number(data.long)}; // Ensure 'lng' is correct

        geocoder.geocode({location: latlng}, (results, status) => {

          if (status === google.maps.GeocoderStatus.OK) {
            if (results[0]) {
              this.location.city = results[0].formatted_address;
              this.location.address = results[0].address_components[1].long_name;
              const data = {
                city: results[0].formatted_address,
                address: results[0].address_components[1].long_name,
                lat: latlng.lat,
                long: latlng.lng
              }
              Cookies.set('current_location', JSON.stringify(data));
            } else {
              console.log("No results found");
            }
            resolve();
          } else {
            console.error("Geocoder failed due to:", status);
            reject();
          }
        });
      });
    },

    async getCurrentLocation() {
      return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
              (position) => {
                resolve(`${position.coords.latitude},${position.coords.longitude}`);
              },
              (error) => {
                console.error("Geolocation error:", error);
                reject(null);
              }
          );
        } else {
          console.error("Geolocation is not supported by this browser.");
          reject(null);
        }
      });
    },


    calculateDistance(origin, destination, branch) {
      return new Promise((resolve) => {
        // Check if Google Maps API is loaded
        if (!window.google?.maps) {
          console.error("Google Maps API not loaded");
          return resolve({ ...branch, distance: null, error: "Google Maps API not loaded" });
        }

        const service = new google.maps.DistanceMatrixService();

        service.getDistanceMatrix(
            {
              origins: [origin],
              destinations: [destination],
              travelMode: google.maps.TravelMode.DRIVING,
              unitSystem: google.maps.UnitSystem.METRIC
            },
            (response, status) => {
              // Handle API response status
              if (status !== google.maps.DistanceMatrixStatus.OK) {
                console.error("Distance Matrix API error:", status);
                return resolve({ ...branch, distance: null, error: status });
              }

              // Validate response structure
              if (!response?.rows?.length || !response.rows[0]?.elements?.length) {
                console.error("Invalid response structure - missing rows/elements", response);
                return resolve({ ...branch, distance: null, error: "Invalid response structure" });
              }

              const element = response.rows[0].elements[0];

              // Check if the distance calculation was successful
              if (element.status === google.maps.DistanceMatrixElementStatus.OK) {
                if (element.distance?.value) {
                  // Success case - return distance in meters
                  return resolve({
                    ...branch,
                    distance: element.distance.value,
                    distanceText: element.distance.text,
                    duration: element.duration?.value,
                    durationText: element.duration?.text
                  });
                }
                console.error("Distance value missing in response", element);
              } else {
                console.error("Distance calculation failed:", element.status);
              }

              // Fallback for any unsuccessful cases
              resolve({ ...branch, distance: null, error: element.status });
            }
        );
      });
    },


    async getSettings() {
      try {
        const url = `/settings/general`;
        const response = await ApiService.get(url);
        if (response.success) {
          this.settings = response.data.data;
          const userInfo = getUserInfo();
          if (userInfo) {
            await this.getBranches(userInfo);
          }
        } else {
          await this.getBranches();
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        await this.getBranches();
      }
    },
    async initData(){
      const userInfo = getUserInfo();
      if (userInfo) {
        this.userInfo = userInfo;
        await this.getAddress();
      }
      const checkGoogleMaps = setInterval(() => {
        if (window.google && window.google.maps) {
          clearInterval(checkGoogleMaps);
          this.calculateDistance();
        }
      }, 500);
      this.setData();
      this.outSideClick();
    },

    async getAddress() {
      try {
        this.getAddressLoading = true;
        const url = `/settings/address/get`;
        const response = await ApiService.post(url, {user_id: this.userInfo.client.id});
        this.addresses = response.data.data;
        if (this.addresses.length > 0) {
          this.selectedLocation.name = this.addresses[0]?.name;
          this.selectedLocation.building_details = this.addresses[0]?.building_details;
        }
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        this.getAddressLoading = false;
      }
    },


    async manageAddress() {
      this.addressError = null;
      if (this.userInfo) {
        try {
          if (this.address.id && (!this.address.name || !this.address.building_details)) {
            this.addressError = {
              name: false,
              building_details: false
            }
            if (!this.address.name) {
              this.addressError.name = true;
            }
            if (!this.address.building_details) {
              this.addressError.building_details = true;
            }
            return;
          }
          this.addressLoading = true;
          const url = this.address.id ? `settings/address/update` : `settings/address/add`;
          this.address = {
            ...this.address,
            user_id: this.userInfo.client.id
          }
          if (this.address.id) {
            this.address.addr_id = String(this.address.id);
          }
          const response = await ApiService.post(url, this.address);
          if (response.data?.error) {
            this.addressError = response.data.error;
          }
          if (response.data.status === 200) {
            if (this.address.id) {
              toaster.info(this.lang == 'en' ? 'Address has been updated successfully.' : 'تم تحديث العنوان بنجاح.');
            } else {
              toaster.info(this.lang == 'en' ? 'Address has been saved successfully.' : 'تم حفظ العنوان بنجاح.');
            }
            if (this.address.id) {
              this.addresses = this.addresses.map(each => {
                if (each.id == this.address.id) {
                  return this.address
                } else {
                  return each;
                }
              })
              this.selectedLocation.name = this.address.name;
              this.selectedLocation.building_details = this.address.building_details;
            } else {
              this.addresses.push(this.address);
            }
            this.address = {
              id: '',
              user_id: '',
              name: '',
              lat: this.activeBranch?.lat,
              long: this.activeBranch?.long,
              alt: '',
              building_details: '',
              type: '',
            }
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.addressLoading = false;
        }
      } else {
        this.authModal = true;
      }
    },

    async deleteAddress() {
      if (this.userInfo) {
        try {
          this.deleteAddressLoading = true;
          const url = `settings/address/delete`;
          const data = {
            user_id: this.userInfo.client.id,
            addr_id: String(this.address.id)
          }
          const response = await ApiService.post(url, data);
          if (response.data.status === 200) {
            toaster.info(this.lang == 'en' ? 'Address has been deleted successfully.' : 'تم حذف العنوان بنجاح.');
            this.getAddress();
            this.address = {
              id: '',
              user_id: '',
              name: '',
              lat: this.activeBranch.lat,
              long: this.activeBranch.long,
              alt: '',
              building_details: '',
              type: '',
            }
          }
        } catch (error) {
          console.error("Error fetching users:", error);
        } finally {
          this.deleteAddressLoading = false;
        }
      }
    },

    openAddress() {
      if (this.showAddress) {
        this.showAddress = false;
      } else {
        this.showAddress = true;
      }
    },

    sentBranchId(branch) {
      this.branches.forEach((each) => {
        if (each.id == branch.id) {
          each.active = true;
        } else {
          each.active = false;
        }
      })
      this.activeBranch = branch;
      this.getLocation({lat: branch.lat, long: branch.long});
      this.$emit('setBranchId', branch.id);
    },

    changeLang(lang) {
      if (lang === 'en') {
        setLang('en');
        window.location.reload();
      } else {
        setLang('ar');
        window.location.reload();
      }
    },

    fetchLanguage() {
      const lang = getLang('lang');

      if (!lang) {
        document.cookie = "lang=en;"
      }
      if (lang === 'en') {
        document.body.style.direction = 'ltr';
        document.body.classList.remove('rtl');
        document.body.classList.add('ltr');
        setLang('en');
        window.core = {
          lang: 'en'
        }
      } else if (lang === 'ar') {
        document.body.style.direction = 'rtl';
        document.body.classList.remove('ltr');
        document.body.classList.add('rtl');
        setLang('ar');
        window.core = {
          lang: 'ar'
        }
      }
    },

    handleSidebar() {
      this.$emit('handleSidebar');
    },

    handleAddress(data) {
      this.address = {
        ...this.address,
        lat: data.lat,
        long: data.lng
      }
      this.getLocation({lat: data.lat, long: data.lng})
    },

    setAddress(data) {
      this.address = data;
      this.selectedLocation.name = data.name;
      this.selectedLocation.building_details = data.building_details;
      Cookies.set('location_id', JSON.stringify(data.id));
      this.showAddress = false;
    },

    setDeliveryStatus(type) {
      if (type == 1) {
        this.deliveryStatus = type;
        Cookies.set('delivery_status', JSON.stringify(type));
      } else {
        this.deliveryStatus = type;
        Cookies.set('delivery_status', JSON.stringify(type));
        this.address = {
          id: '',
          user_id: '',
          name: '',
          lat: this.activeBranch?.lat,
          long: this.activeBranch?.long,
          alt: '',
          building_details: '',
          type: '',
        }
      }
    },

    outSideClick() {
      window.addEventListener('click', (e) => {
        const officeAddress = document.getElementById('officeAddress');
        const locationBtn = document.getElementById('locationBtn');
        if ((officeAddress && !officeAddress.contains(e.target)) && (locationBtn && !locationBtn.contains(e.target))) {
          this.showAddress = false;
        }
      })
    },

    setData() {
      Cookies.remove('location_id');
      Cookies.set('delivery_status', JSON.stringify(1));
    },

    handleCloseModal(){
      this.authModal = false;
    },

  },
  mounted() {
    this.fetchLanguage();
    this.getSettings();
  }
}
</script>